// 消息推送
export default {
    time: '时间',
    startTime: '开始日期',
    endTime: '结束日期',
    to: '至',
    userName: '帐号名称',
    roleName: '角色名称',
    operate: '操作',
    department: '部门',
    personName: '帐号',
    role: '角色',
    select: '请选择',

}
